import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

/**
 * Method create path with dynamic parameters and search parameters
 *
 * @memberOf module:routes
 * @param {string} pathname - path
 * @param {Object} obj - dynamic values to be replaced in the path
 * @param includeSearch - true if search params should be added in the path
 *
 * @returns {string}
 * */
function generateDynamicPathname(pathname, obj, includeSearch = true) {
  let resultPathname = pathname;

  Object.entries(obj).forEach(([key, value]) => {
    resultPathname = resultPathname.replace(`:${key}`, value);
  });
  if (includeSearch) {
    resultPathname = generatePathnameWithSearch(resultPathname);
  }
  return resultPathname;
}

/**
 * Method create path with search parameters
 *
 * @memberOf module:routes
 * @param {string} pathname - path
 * @param {Object.<string, string>} [addedSearchParams] - parameters to be added to the path
 * @param {string|string[]} [removedSearchParams] - parameters to be removed from the path
 * @returns {string}
 * */
function generatePathnameWithSearch(pathname, addedSearchParams, removedSearchParams) {
  let urlStringifyObject = '';
  let searchParams = history.location.search;

  if (addedSearchParams && typeof addedSearchParams === 'object') {
    urlStringifyObject = new URLSearchParams(addedSearchParams).toString();
  }

  if (urlStringifyObject) {
    searchParams = `${searchParams}${!searchParams ? '?' : '&'}${urlStringifyObject}`;
  }

  if (removedSearchParams) {
    searchParams = new URLSearchParams(searchParams);
    if (typeof removedSearchParams === 'string') {
      searchParams.delete(removedSearchParams);
    } else if (Array.isArray(removedSearchParams)) {
      removedSearchParams.forEach((removedSearchParam) => {
        searchParams.delete(removedSearchParam);
      });
    }
    if (searchParams.toString()) {
      searchParams = `?${searchParams}`;
    }
  }

  return `${pathname}${searchParams}`;
}

export { generateDynamicPathname, generatePathnameWithSearch };
export default history;
